export default class ApiUtils {
    static encodeValues(val) {
        if (typeof val === 'object' && !Array.isArray(val)) {
            let keys = Object.keys(val);
            keys.forEach((key) => {
                val[key] = encodeURIComponent(val[key]);
            });
            return val;
        } else if (typeof val === 'string') {
            return encodeURIComponent(val);
        }
    }

    static requestHeaders() {
        return { 'AUTHORIZATION': `Bearer ${localStorage.getItem("token")}` };
    }

    static handleError(err) {
        let errorObject = JSON.parse(JSON.stringify(err))
        let errorMsg = 'Error contacting server. ';

        let moreErrors = [];

        console.log('ERROR' + JSON.stringify(errorObject));

        if((errorObject.response) && (errorObject.response.data) && (errorObject.response.data.message)) moreErrors.push(errorObject.response.data.message);
        if(err.message) moreErrors.push(err.message);
        if (err.errors){
            if(Array.isArray(err.errors) && err.errors.length > 0){
                err.errors.forEach(function(error){
                    moreErrors.push(error.message);
                })
            }else if(err.errors.code){
                moreErrors.push(err.errors.code);
            }else if(err.errors.message){
                moreErrors.push(err.errors.message);
            }else{
                moreErrors.push(err.errors);
            }
        }


        if(moreErrors.length > 0){
            //errorMsg = errorMsg + "<ul style=\"list-style:none\">";
            moreErrors.forEach(function(error){
                //errorMsg = errorMsg + "<li>" + error + "</li>";
                errorMsg = errorMsg + error + ". ";
            });
            //errorMsg = errorMsg + "</ul>";
        }

        return Promise.reject(errorMsg);
    }
}


// WEBPACK FOOTER //
// ./src/api/apiUtils.js